import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=3f6c49a5&scoped=true"
import script from "./ModalTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalTemplate.vue?vue&type=style&index=0&id=3f6c49a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c49a5",
  null
  
)

export default component.exports